<!-- ======= Header ======= -->
<header id="header">
  <div class="container-fluid">
    <div class="brand-logo float-left">
      <a href="#page-top"><img src="assets/images/logo-2-inverted.png" alt="" class="img-fluid"></a>
    </div>
    <a class="navbar-brand brand-name js-scroll" href="#page-top"> Management Consulting</a>
  </div>
</header><!-- End #header -->

<!-- ======= Hero Section ======= -->
<section id="hero">
  <div class="hero-container">
    <h1>Consulting with a Digital Edge</h1>
    <p>We understand that Management Consulting is changing, it is no longer about fancy presentations and long reports and it never should have been.</p>
    <p>That's why we are building a suite of Digital Consulting products that gives clients insights and understanding into their performance and strategy execution.</p>
    <p>We are currently working with a group of select clients before launching our solutions later this year</p>
    <p>Stay tuned for more information by following us on LinkedIn below</p>
    <div id="linkedin"></div>
  </div>
</section><!-- End Hero -->

<main id="main">

</main><!-- End #main -->

<!-- ======= Footer ======= -->
<footer id="footer">
  <div class="container">
    <div class="copyright">
      &copy; Copyright <strong><span>PMR Management Consulting</span></strong>. All Rights Reserved
    </div>
  </div>
</footer><!-- End #footer -->
